import {useCallback,useEffect,useRef,useState} from 'react';
import {SchoolEvent} from 'models/event';
import {getAllTournamentActiveEvents} from 'services/Tournaments/events';

export function useIndividualTournamentLiveData(schoolId:string,tournamentId:string,refreshMs=15000){
  const [events,setEvents]=useState<SchoolEvent[]>([]);
  const [isLoading,setIsLoading]=useState(true);
  const [error,setError]=useState('');
  const mounted=useRef(true);
  const generation=useRef(0);
  const pending=useRef(false);
  const refresh=useCallback(async(showLoader=false)=>{
    if(!schoolId||!tournamentId){setIsLoading(false);setError('Tournament details are unavailable.');return;}
    if(pending.current)return;
    pending.current=true;
    const currentGeneration=generation.current;
    if(showLoader)setIsLoading(true);
    try{const data=await getAllTournamentActiveEvents(schoolId,tournamentId,{},true);if(mounted.current&&currentGeneration===generation.current){setEvents(data);setError('');}}
    catch{if(mounted.current&&currentGeneration===generation.current)setError('Live tournament data could not be refreshed.');}
    finally{if(currentGeneration===generation.current){pending.current=false;if(mounted.current)setIsLoading(false);}}
  },[schoolId,tournamentId]);
  useEffect(()=>{mounted.current=true;generation.current++;pending.current=false;setEvents([]);setError('');refresh(true);const timer=window.setInterval(()=>refresh(false),refreshMs);return()=>{mounted.current=false;generation.current++;window.clearInterval(timer);};},[refresh,refreshMs]);
  return {events,isLoading,error,refresh};
}
